/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_TitleInputs */

const cs_import_tokens_title = /** @type {(inputs: Import_Tokens_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT tokeny pro import`)
};

const en_import_tokens_title = /** @type {(inputs: Import_Tokens_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT import tokens`)
};

/**
* | output |
* | --- |
* | "IT import tokens" |
*
* @param {Import_Tokens_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_title = /** @type {((inputs?: Import_Tokens_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_title(inputs)
	return cs_import_tokens_title(inputs)
});